// extracted by mini-css-extract-plugin
export default {"LandingPage":"suspensePage_LandingPage__XJAms"};